// Mock data for Bhargava Shoes website

export const heroData = {
  title: "BHARGAVA'S SHOES",
  subtitle: "A NAME IN FOOTWEAR SINCE 1911",
  tagline: "FLEX WALE",
  description: "Discover premium footwear for every occasion at Sadar Bazar, Bathinda",
  cta: "Explore Collection"
};

export const productCategories = [
  {
    id: 1,
    slug: "mens-footwear",
    name: "Men's Footwear",
    description: "Premium leather shoes, formal and casual styles",
    image: "https://images.pexels.com/photos/298864/pexels-photo-298864.jpeg",
    items: 150
  },
  {
    id: 2,
    slug: "womens-footwear",
    name: "Women's Footwear",
    description: "Elegant heels, sandals, and designer collections",
    image: "https://images.unsplash.com/photo-1581101767113-1677fc2beaa8",
    items: 200
  },
  {
    id: 3,
    slug: "kids-footwear",
    name: "Kids' Footwear",
    description: "Comfortable and stylish shoes for children",
    image: "https://images.unsplash.com/photo-1519226719127-9e805abb99b1",
    items: 80
  },
  {
    id: 4,
    slug: "formal-collection",
    name: "Formal Collection",
    description: "Sophisticated footwear for business and special occasions",
    image: "https://images.unsplash.com/photo-1709282028322-35c1fb068ef8",
    items: 120
  },
  {
    id: 5,
    slug: "casual-wear",
    name: "Casual Wear",
    description: "Comfortable everyday shoes and sneakers",
    image: "https://images.unsplash.com/photo-1643581278958-413530f40933",
    items: 180
  },
  {
    id: 6,
    slug: "sports-collection",
    name: "Sports Collection",
    description: "Performance footwear for active lifestyles",
    image: "https://images.unsplash.com/photo-1760302318631-a8d342cd4951",
    items: 100
  },
  {
    id: 7,
    slug: "traditional-ethnic",
    name: "Traditional & Ethnic",
    description: "Authentic Indian footwear and traditional styles",
    image: "https://images.unsplash.com/photo-1553710095-10f8a9a51053",
    items: 90
  }
];

// Extended product images for each category
export const categoryProducts = {
  "mens-footwear": [
    { id: 1, name: "Classic Leather Oxford", price: "₹2,499", image: "https://images.pexels.com/photos/298864/pexels-photo-298864.jpeg" },
    { id: 2, name: "Premium Loafers", price: "₹1,999", image: "https://images.unsplash.com/photo-1614252235316-8c857d38b5f4" },
    { id: 3, name: "Formal Derby Shoes", price: "₹2,799", image: "https://images.unsplash.com/photo-1533867617858-e7b97e060509" },
    { id: 4, name: "Casual Sneakers", price: "₹1,799", image: "https://images.unsplash.com/photo-1605348532760-6753d2c43329" },
    { id: 5, name: "Monk Strap Shoes", price: "₹2,999", image: "https://images.unsplash.com/photo-1478269046155-f5d5c7b9c19d" },
    { id: 6, name: "Chelsea Boots", price: "₹3,499", image: "https://images.unsplash.com/photo-1608256246200-53e635b5b65f" },
  ],
  "womens-footwear": [
    { id: 1, name: "Glitter Heels", price: "₹3,299", image: "https://images.unsplash.com/photo-1581101767113-1677fc2beaa8" },
    { id: 2, name: "Designer Sandals", price: "₹2,499", image: "https://images.unsplash.com/photo-1709282028322-35c1fb068ef8" },
    { id: 3, name: "Elegant Pumps", price: "₹2,799", image: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2" },
    { id: 4, name: "Ankle Strap Heels", price: "₹2,999", image: "https://images.unsplash.com/photo-1553710095-10f8a9a51053" },
    { id: 5, name: "Platform Sandals", price: "₹2,199", image: "https://images.unsplash.com/photo-1572274407649-e7e0c7ecbd58" },
    { id: 6, name: "Ballerina Flats", price: "₹1,799", image: "https://images.unsplash.com/photo-1603808033192-082d6919d3e1" },
  ],
  "kids-footwear": [
    { id: 1, name: "Kids Sneakers", price: "₹1,299", image: "https://images.unsplash.com/photo-1514989940723-e8e51635b782" },
    { id: 2, name: "School Shoes", price: "₹999", image: "https://images.unsplash.com/photo-1588117305388-c2631a279f82" },
    { id: 3, name: "Sports Shoes", price: "₹1,499", image: "https://images.unsplash.com/photo-1560769629-975ec94e6a86" },
    { id: 4, name: "Sandals", price: "₹799", image: "https://images.unsplash.com/photo-1519226719127-9e805abb99b1" },
    { id: 5, name: "Casual Loafers", price: "₹899", image: "https://images.unsplash.com/photo-1618932260643-eee4a2f652a6" },
    { id: 6, name: "Party Shoes", price: "₹1,199", image: "https://images.unsplash.com/photo-1598033129183-c4f50c736f10" },
  ],
  "formal-collection": [
    { id: 1, name: "Wedding Shoes", price: "₹3,999", image: "https://images.unsplash.com/photo-1519226719127-9e805abb99b1" },
    { id: 2, name: "Office Formals", price: "₹2,499", image: "https://images.unsplash.com/photo-1533867617858-e7b97e060509" },
    { id: 3, name: "Party Loafers", price: "₹2,799", image: "https://images.unsplash.com/photo-1614252235316-8c857d38b5f4" },
    { id: 4, name: "Dress Shoes", price: "₹2,999", image: "https://images.unsplash.com/photo-1478269046155-f5d5c7b9c19d" },
    { id: 5, name: "Oxford Brogues", price: "₹3,299", image: "https://images.pexels.com/photos/298864/pexels-photo-298864.jpeg" },
    { id: 6, name: "Derby Collection", price: "₹2,699", image: "https://images.unsplash.com/photo-1608256246200-53e635b5b65f" },
  ],
  "casual-wear": [
    { id: 1, name: "Canvas Sneakers", price: "₹1,499", image: "https://images.unsplash.com/photo-1643581278958-413530f40933" },
    { id: 2, name: "Slip-On Shoes", price: "₹1,299", image: "https://images.unsplash.com/photo-1560769629-975ec94e6a86" },
    { id: 3, name: "Casual Loafers", price: "₹1,799", image: "https://images.unsplash.com/photo-1614252235316-8c857d38b5f4" },
    { id: 4, name: "Walking Shoes", price: "₹1,999", image: "https://images.unsplash.com/photo-1560769629-975ec94e6a86" },
    { id: 5, name: "Boat Shoes", price: "₹1,699", image: "https://images.unsplash.com/photo-1605348532760-6753d2c43329" },
    { id: 6, name: "Espadrilles", price: "₹1,399", image: "https://images.unsplash.com/photo-1533867617858-e7b97e060509" },
  ],
  "sports-collection": [
    { id: 1, name: "Running Shoes", price: "₹2,999", image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff" },
    { id: 2, name: "Training Shoes", price: "₹2,499", image: "https://images.unsplash.com/photo-1560769629-975ec94e6a86" },
    { id: 3, name: "Basketball Shoes", price: "₹3,499", image: "https://images.unsplash.com/photo-1608231387042-66d1773070a5" },
    { id: 4, name: "Tennis Shoes", price: "₹2,799", image: "https://images.unsplash.com/photo-1760302318631-a8d342cd4951" },
    { id: 5, name: "Gym Trainers", price: "₹2,199", image: "https://images.unsplash.com/photo-1549298916-b41d501d3772" },
    { id: 6, name: "Athletic Sneakers", price: "₹2,699", image: "https://images.unsplash.com/photo-1605348532760-6753d2c43329" },
  ],
  "traditional-ethnic": [
    { id: 1, name: "Punjabi Juttis", price: "₹1,299", image: "https://images.unsplash.com/photo-1553710095-10f8a9a51053" },
    { id: 2, name: "Mojaris", price: "₹1,499", image: "https://images.unsplash.com/photo-1603808033192-082d6919d3e1" },
    { id: 3, name: "Kolhapuri Chappals", price: "₹899", image: "https://images.unsplash.com/photo-1572274407649-e7e0c7ecbd58" },
    { id: 4, name: "Ethnic Sandals", price: "₹1,099", image: "https://images.unsplash.com/photo-1709282028322-35c1fb068ef8" },
    { id: 5, name: "Designer Juttis", price: "₹1,799", image: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2" },
    { id: 6, name: "Traditional Footwear", price: "₹1,199", image: "https://images.unsplash.com/photo-1598033129183-c4f50c736f10" },
  ]
};

export const aboutData = {
  title: "About Bhargava's Shoes",
  since: "Since 1911",
  description: "Established as a premier footwear destination in Bathinda since 1911, Bhargava's Shoes has been serving customers with exceptional quality and style for over a century. Located in the heart of Sadar Bazar, we pride ourselves on offering an extensive collection of footwear for men, women, and children.",
  mission: "Our mission is to provide our customers with the finest selection of footwear that combines comfort, style, and durability. We believe that the right pair of shoes can transform not just your outfit, but your entire day.",
  values: [
    "Quality craftsmanship",
    "Customer satisfaction",
    "Authentic brands",
    "Competitive pricing"
  ]
};

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1581101767113-1677fc2beaa8",
    alt: "Luxury women's heels",
    category: "Women's"
  },
  {
    id: 2,
    url: "https://images.pexels.com/photos/298864/pexels-photo-298864.jpeg",
    alt: "Premium men's shoes",
    category: "Men's"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1519226719127-9e805abb99b1",
    alt: "Luxury wedding shoes",
    category: "Formal"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1709282028322-35c1fb068ef8",
    alt: "Designer sandals",
    category: "Women's"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1760302318631-a8d342cd4951",
    alt: "Showroom display",
    category: "Store"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1698664434415-03203ce8acc7",
    alt: "Shoe collection",
    category: "Store"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    rating: 5,
    text: "Best shoe showroom in Bathinda! Amazing collection and great service. Found the perfect formal shoes for my office.",
    date: "2025-01-10"
  },
  {
    id: 2,
    name: "Priya Sharma",
    rating: 5,
    text: "Bhargava's Shoes has an incredible selection of women's footwear. The staff is knowledgeable and helped me find the perfect pair for my wedding.",
    date: "2025-01-08"
  },
  {
    id: 3,
    name: "Amit Singh",
    rating: 5,
    text: "Quality products at reasonable prices. I've been a loyal customer for years. Highly recommend for all your footwear needs.",
    date: "2025-01-05"
  },
  {
    id: 4,
    name: "Neha Gupta",
    rating: 5,
    text: "Excellent variety of kids' shoes! My children love their new sneakers. The comfort and quality are outstanding.",
    date: "2024-12-28"
  }
];

export const instagramPosts = [
  {
    id: "mock_1",
    media_url: "https://images.unsplash.com/photo-1581101767113-1677fc2beaa8",
    caption: "New arrival! ✨ Elegant designer heels perfect for special occasions. Visit us at Sadar Bazar, Bathinda. #BhargavaShoes #LuxuryFootwear",
    permalink: "https://instagram.com/bhargavashoesbti",
    timestamp: "2025-01-15T10:30:00Z",
    like_count: 234,
    comments_count: 18
  },
  {
    id: "mock_2",
    media_url: "https://images.pexels.com/photos/298864/pexels-photo-298864.jpeg",
    caption: "Premium leather collection for men 👞 Crafted with precision and style. #MensFootwear #BhargavaShoes",
    permalink: "https://instagram.com/bhargavashoesbti",
    timestamp: "2025-01-14T15:20:00Z",
    like_count: 189,
    comments_count: 12
  },
  {
    id: "mock_3",
    media_url: "https://images.unsplash.com/photo-1519226719127-9e805abb99b1",
    caption: "Wedding season special! Beautiful formal footwear for your special day 💍 #WeddingShoes #Bathinda",
    permalink: "https://instagram.com/bhargavashoesbti",
    timestamp: "2025-01-13T12:00:00Z",
    like_count: 312,
    comments_count: 25
  },
  {
    id: "mock_4",
    media_url: "https://images.unsplash.com/photo-1709282028322-35c1fb068ef8",
    caption: "Summer collection is here! ☀️ Stylish sandals for the season. #SummerFootwear #Fashion",
    permalink: "https://instagram.com/bhargavashoesbti",
    timestamp: "2025-01-12T09:45:00Z",
    like_count: 267,
    comments_count: 21
  },
  {
    id: "mock_5",
    media_url: "https://images.unsplash.com/photo-1760302318631-a8d342cd4951",
    caption: "Our showroom is ready for you! 🏪 Come explore our extensive collection. #BhargavaShoesShowroom",
    permalink: "https://instagram.com/bhargavashoesbti",
    timestamp: "2025-01-11T14:30:00Z",
    like_count: 156,
    comments_count: 9
  },
  {
    id: "mock_6",
    media_url: "https://images.unsplash.com/photo-1698664434415-03203ce8acc7",
    caption: "Walk in style! Our latest collection will turn heads everywhere you go 👠 #StyleStatement",
    permalink: "https://instagram.com/bhargavashoesbti",
    timestamp: "2025-01-10T11:15:00Z",
    like_count: 198,
    comments_count: 14
  }
];

export const contactInfo = {
  name: "Bhargava's Shoes",
  address: "4952, Sadar Bazar Road, Old City, Mall Road, Bathinda, Punjab 151001",
  phone: "9041930007",
  email: "info@bhargavashoes.com",
  hours: {
    weekdays: "10:00 AM - 9:00 PM",
    weekends: "10:00 AM - 10:00 PM"
  },
  social: {
    instagram: "https://instagram.com/bhargavashoesbti"
  },
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3446.3!2d74.95!3d30.21!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzDCsDEyJzM2LjAiTiA3NMKwNTcnMDAuMCJF!5e0!3m2!1sen!2sin!4v1234567890"
};
